var $ = require('jquery');
require('./jquery.easing');
var LocalStorageSupport = require('./LocalStorageSupport');
"use strict";

var	DEFAULTS = {
	localStorageKey: 'KM_FLAG_PRODUCT_DISCLAIMER_AGREED',
	url: '',
	htmlClass: ''
};

/**
 *
 * @param options
 * @constructor
 */
var BrandDisclaimer = function (options) {
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

/**
 * Init function
 * @private
 */
BrandDisclaimer.prototype.initialise_ = function() {
	this.ls = new LocalStorageSupport();
	this.disclaimerEnabled = this.checkValidity_();
	this.canBeClosed = false;
};

BrandDisclaimer.prototype.showDisclaimer = function() {
	this.disclaimerEnabled = this.checkValidity_();
	if (this.$wrapper instanceof $) {
		return false;
	}

	if (this.disclaimerEnabled) {
		this.renderWrapper_();
		this.getDisclaimerData_();
	}
};

BrandDisclaimer.prototype.checkValidity_ = function() {
	return !this.ls.getItem(this.options.localStorageKey);
};

BrandDisclaimer.prototype.renderWrapper_ = function() {
	this.$wrapper = $('<div class="km-brand-disclaimer-wrapper"></div>').appendTo($('body'));
	this.$wrapper.css({
		position: 'absolute',
		top: '0',
		left: '0',
		width: '100%',
		height: '100%',
		background: 'rgba(0,0,0,0.8)',
		'z-index' : '2147483647'
	});
};

BrandDisclaimer.prototype.getDisclaimerData_ = function() {
	var self_ = this;
	if (this.options.url) {
		$.getJSON(this.options.url, function(data) {
			self_.renderDisclaimer_(data);
			self_.bindControlEvents_();
		});
	}
};

BrandDisclaimer.prototype.renderDisclaimer_ = function(data) {
	this.$popup =  $('<div class="'+this.options.htmlClass+'"></div>');
	this.$popupIn =  $('<div></div>').appendTo(this.$popup);
	this.$popupIn.append('<div class="disclaimer-content">' + data.content + '</div>');
	this.$agreeCheckbox = $('<p class="'+this.options.htmlClass+'-checkbox"><input type="checkbox" value="1" class="mask-disclaimer" id="id-'+this.options.htmlClass+'-checkbox"/><label for="id-'+this.options.htmlClass+'-checkbox">'+data.checkbox+'</label></p>').appendTo(this.$popupIn);
	this.$button = $('<p class="buttons ac mb-quart"><a class="btn btn-default disabled" href="javascript:void(0)">Pokračovat</a></p>').appendTo(this.$popupIn);
	this.$popup.appendTo(this.$wrapper);
};

BrandDisclaimer.prototype.bindControlEvents_ = function() {
	var self_ = this;
	this.$agreeCheckbox.on('click', 'input', function() {
		self_.canBeClosed = !self_.canBeClosed;
		$('.btn', self_.$button).toggleClass('disabled');
	});

	this.$button.on('click', '.btn', function() {
		self_.destroyDisclaimerAndSaveState_();
	});
};

BrandDisclaimer.prototype.destroyDisclaimerAndSaveState_ = function() {
	var self_ = this;
	this.$popup.animate({
		left: '-100%'
	}, 400, function() {
		self_.$wrapper.fadeOut(400, function() {
			self_.$wrapper.remove();
			self_.ls.setItem(self_.options.localStorageKey, true);
		});
	});
};


module.exports = BrandDisclaimer;





// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/BrandDisclaimer.js